import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onLoaderTrigger } from "redux/actions/commonAction";
import store from "redux/store";
import { GET_PROFILE } from "resources/actionTypes";
import { profileService } from "services/ProfileService";
import { rolesEnum } from "utils/enumObj";

function* getProfileListener(action) {
  const payload = action.payload || '';

  if(payload?.payloadType) {
    store.dispatch(onLoaderTrigger(true));
  }
  
  const userProfile = yield call(profileService);

  if (userProfile?.success) {
    localStorage.setItem("role", userProfile?.data?.role);
    userProfile?.data?.id &&
    localStorage.setItem("user", JSON.stringify(userProfile?.data));

    const companyID = localStorage.getItem("subCompany")?.length > 0 && JSON.parse(localStorage.getItem("subCompany"));

    if(!companyID?.value) {
      const companyList = userProfile?.data?.companies?.map((data, index ) => ({label: data?.name, value: data?.id}));
      const tempList = companyList?.length ? companyList : [{value: userProfile?.data?.companyId || "", label: userProfile?.data?.companyName || ""}]
      localStorage.setItem("subCompany", JSON.stringify(tempList?.[0]));
    }

    if(payload?.payloadType) {
      if(parseInt(userProfile?.data?.role) === rolesEnum?.employee){
        window.location.replace(`/front-desk/${"all"}`);
      } else {
        window.location.replace(`/front-desk/${"dashboard"}`);
      }
    }

    yield put({
      type: GET_PROFILE.GET_PROFILE_SUCCESS,
      userProfile: userProfile,
    });
  } else {
    yield put({
      type: GET_PROFILE.GET_PROFILE_FAILED,
      message: userProfile.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(userProfile?.message || "Fetching Profile failed");
  }
}

export function* getProfileSaga() {
  yield takeEvery(GET_PROFILE.GET_PROFILE_REQUESTED, getProfileListener);
}
